<template>
    <div class="publication__gallery content-width" ref="gallery">

        <div class="publication__gallery-row d-flex" ref="galleryContainer">
            <canvas class="publication__gallery-canvas" ref="canvas"></canvas>
            <template v-if="previewImages.length">
                <div class="publication__gallery-item d-flex" v-for="(image, idx) in previewImages" :key="idx">

                    <div class="publication__gallery-item-inner d-flex">

                        <div class="publication__invalid d-flex" v-if="image.size > 20971520">

                            Изображение слишком большое и не будет загружено!

                        </div>

                        <img class="publication__gallery-image" :src="image.base64" alt="">

                        <div class="publication__gallery-nav d-flex">
                            <a href="#" @click.prevent="canvasDrawImage( idx, {flip: [-1, 1]} )">
                                <img src="/assets/images/icons/flipH.svg" alt="">
                            </a>
                            <a href="#" @click.prevent="canvasDrawImage( idx, {flip: [1, -1]} )">
                                <img src="/assets/images/icons/flipV.svg" alt="">
                            </a>
                            <a href="#" @click.prevent="canvasDrawImage( idx, {degree: 90} )">
                                <img src="/assets/images/icons/rotateF.svg" alt="">
                            </a>
                            <a href="#" @click.prevent="canvasDrawImage( idx, {degree: -90} )">
                                <img src="/assets/images/icons/rotateB.svg" alt="">
                            </a>
                            <a href="#" @click.prevent="deletePhoto(idx)">
                                <span class="lnr lnr-cross" style="cursor:pointer;" ></span>
                            </a>
                        </div>
                    </div>


                </div>
            </template>

            <div class="publication__gallery-item d-flex" ref="galleryItem">
                <div class="publication__gallery-item-inner d-flex">
                    <div class="publication__fieldset-upload">
                        <label class="publication__fieldset-upload-btn d-flex">
                            <input type="file" accept=".jpeg,.png,.jpg" @change="addImages" multiple>
                            <img src="/assets/images/icons/publication-add.svg" alt="">
                            Добавить фото

                        </label>
                    </div>
                </div>
            </div>


        </div>

        <div class="text-danger" v-if="$v.stateImages.$error" >Неверное значение.</div>

    </div>
</template>

<script>

import { requiredIf } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "PublicationSliderGallery",
    props: ['server'],
    mixins: [StateMixin],
    data(){
        return{
            images: [],
        }
    },


    computed: {

        delete_images_ids: {
            get() { return this.GET_BY_KEY('delete_images_ids') },
            set( val ) {
                this.SET_BY_KEY({ key: 'delete_images_ids', data: val })
            }
        },

        previewImages: {
            get() { return this.GET_BY_KEY('previewImages') },
            set( val ) {
                this.SET_BY_KEY({ key: 'previewImages', data: val })
            }
        },

        stateImages: {
            get() { return this.GET_BY_KEY('images') },
            set( val ) {
                this.SET_BY_KEY({ key: 'images', data: val })
            }
        },
    },

    methods:{

        canvasDrawImage( idx, {degree = null, flip = null} ){
            const img = new Image(),
                canvas = this.$refs.canvas,
                ctx = canvas.getContext('2d');

            img.src = this.previewImages[ idx ].base64;

            let _w, _h, pixelsCount, imgQuality;

            const rotate = () => {

                ctx.clearRect(0,0,canvas.width,canvas.height);
                ctx.save();

                canvas.width = _h;
                canvas.height = _w;

                // reduce quality if image too huge
                let imgQuality = 1.0;
                let pixelsCount = _h * _w;
                if ( pixelsCount > 4000000) {
                    imgQuality = 0.5
                } else if ( pixelsCount > 2000000) {
                    imgQuality = 0.75
                } else if ( pixelsCount > 1000000) {
                    imgQuality = 0.85
                }

                ctx.translate(canvas.width/2,canvas.height/2);

                ctx.rotate(degree*Math.PI/180);
                ctx.drawImage(img,-img.width/2,-img.height/2);

                this.SET_ARRAY_INDEX({array: 'previewImages', idx , data: {base64: canvas.toDataURL('image/jpeg', imgQuality)}});

                if( this.previewImages[ idx ].id !== undefined ){
                    this.delete_images_ids = [ ...this.delete_images_ids, this.previewImages[ idx ].id ]
                }

                this.stateImages = this.previewImages.map( (el) =>  el.base64 );

                ctx.restore();
            };

            const flipFN = () => {
                ctx.clearRect(0,0,canvas.width,canvas.height);
                ctx.save();

                ctx.translate(canvas.width/2,canvas.height/2);

                ctx.scale(flip[0], flip[1]);
                ctx.drawImage(img, -img.width / 2, -img.height / 2, img.width, img.height );

                this.SET_ARRAY_INDEX({array: 'previewImages', idx , data: {base64: canvas.toDataURL('image/jpeg', imgQuality)}});

                if( this.previewImages[ idx ].id !== undefined ){
                    this.delete_images_ids = [ ...this.delete_images_ids, this.previewImages[ idx ].id ]
                }

                this.stateImages = this.previewImages.map( (el) =>  el.base64 );

                ctx.restore();

            };

            img.onload = function() {
                _w = img.width; _h = img.height;

                canvas.width = _w;
                canvas.height = _h;

                // reduce quality if image too huge
                imgQuality = 1.0;
                pixelsCount = _h * _w;
                if ( pixelsCount > 4000000) {
                    imgQuality = 0.5
                } else if ( pixelsCount > 2000000) {
                    imgQuality = 0.75
                } else if ( pixelsCount > 1000000) {
                    imgQuality = 0.85
                }

                if( degree ){
                    rotate();
                }

                if( flip ){
                    flipFN();
                }


            }

        },

        handleHeight(){

            if( this.$refs.gallery && this.$refs.galleryItem && this.$refs.galleryContainer ) {

                const _h  = this.$refs.galleryItem.clientHeight,
                      _i  = Math.ceil(+(this.$refs.galleryContainer.clientWidth / this.$refs.galleryItem.clientWidth).toFixed(1));

                this.$parent.handleSliderHeight((Math.ceil(((this.previewImages.length + 1) / _i)) * _h))

            }

        },

        addImages(e) {

            let files = e.target.files;
            this.images = [];

            for (let key in files) {
                if (e.target.files[key] instanceof File) {
                    this.images.push(e.target.files[key]);
                }
            }

            e.target.value = ''

        },

        deletePhoto(index) {

            if ( this.previewImages[index].id !== undefined && ! this.delete_images_ids.includes( this.previewImages[index].id ) ) {
                this.delete_images_ids = [...this.delete_images_ids, this.previewImages[index].id ];
            }

            this.previewImages = this.previewImages.filter( (el, i) => i !== index );
            this.stateImages = this.previewImages.map( e => e.base64 );

            this.handleHeight();

        },

        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )
            return true

        }

    },

    validations: {
        stateImages: {
            required: requiredIf( function() {

                if( ! ( window.location.pathname.search(/\/homestay\/\d+$/g) >= 0 ) ) return true;

                if( ! this.previewImages.length ) return true;

            } )
        },
    },

    watch: {
        images() {
            let self = this;

            new Promise( res => {

                self.images.forEach(function (image) {
                    if (typeof FileReader === "function") {
                        const reader = new FileReader();

                        reader.onload = event => {


                            if ($.inArray(event.target.result, self.stateImages) === -1) {
                                const img = new Image();
                                img.src = event.target.result
                                img.onload = () => {

                                    self.previewImages = [
                                        ...self.previewImages,
                                        {
                                            'base64': event.target.result,
                                            'name': image.name,
                                            'size': image.size,
                                        }
                                    ]

                                    self.stateImages = [...self.stateImages, event.target.result ]

                                }

                            }



                        };
                        reader.readAsDataURL(image);
                    }
                });

            } )

        },

        previewImages:{
           handler() {  this.handleHeight() },
           deep: true
        },

    }

}
</script>

<style scoped>

</style>
